module.exports = __webpack_public_path__ + "static/flags/NR-1148528284ebb0c14a73616c8af5d908.gif";